import { render } from "./Translates.vue?vue&type=template&id=56871db9&scoped=true"
import script from "./Translates.vue?vue&type=script&lang=js"
export * from "./Translates.vue?vue&type=script&lang=js"

import "./Translates.vue?vue&type=style&index=0&id=56871db9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56871db9"]])

export default __exports__